/**
 * Research Draft Generation API client
 */

import { apiClient } from './client'

export type SectionType = 
  | 'introduction' 
  | 'literature_review' 
  | 'methodology' 
  | 'results_discussion' 
  | 'conclusion'

export interface DraftGenerationRequest {
  section_type: SectionType
  user_context: string // REQUIRED: What the writer wants to write about
  document_id: string
  profile_id?: string
  selected_citation_ids?: string[] // Selected citations from library
  options?: {
    tone?: string
    length?: string
    citation_density?: string
    custom_instructions?: string
  }
}

export interface DraftGenerationResponse {
  content: string
  citations_used: string[]
  section_type: string
  word_count: number
  success: boolean
}

export interface ContentRefinementRequest {
  content: string
  instruction: string
  document_id: string
  profile_id?: string
}

export interface ContentRefinementResponse {
  refined_content: string
  success: boolean
}

class ResearchDraftsAPI {
  /**
   * Generate an academic section based on user context and selected citations
   */
  async generateDraft(
    request: DraftGenerationRequest
  ): Promise<DraftGenerationResponse> {
    return await apiClient.post('/api/research/drafts/generate', request)
  }

  /**
   * Refine existing content based on instruction
   */
  async refineContent(
    request: ContentRefinementRequest
  ): Promise<ContentRefinementResponse> {
    return await apiClient.post('/api/research/drafts/refine', request)
  }
}

export const researchDraftsAPI = new ResearchDraftsAPI()
export default researchDraftsAPI

